(function () {
  const delay = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

  const normalizeRoot = (root) => {
    if (!root) return '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const buildShippingParams = (estimator) => {
    const params = new URLSearchParams();
    const country = estimator.querySelector('[data-solvi-shipping-country]')?.value.trim();
    const province = estimator.querySelector('[data-solvi-shipping-province]')?.value.trim();
    const zip = estimator.querySelector('[data-solvi-shipping-zip]')?.value.trim();

    if (country) params.set('shipping_address[country]', country);
    if (province) params.set('shipping_address[province]', province);
    if (zip) params.set('shipping_address[zip]', zip);

    return params;
  };

  const formatRatePrice = (rate, currencySymbol) => {
    if (rate.presentment_name && rate.price) return `${currencySymbol}${rate.price}`;
    if (rate.price) return `${currencySymbol}${rate.price}`;
    return '';
  };

  class SolviShippingEstimator {
    constructor(estimator) {
      this.estimator = estimator;
      this.summary = estimator.closest('[data-solvi-cart-root]');
      this.root = normalizeRoot(this.summary?.dataset.solviCartRoot || window.Shopify?.routes?.root || '/');
      this.currencySymbol = this.summary?.dataset.solviCartCurrencySymbol || '$';
      this.button = estimator.querySelector('[data-solvi-shipping-submit]');
      this.result = estimator.querySelector('[data-solvi-shipping-result]');

      this.button?.addEventListener('click', () => this.estimate());
    }

    async estimate() {
      const params = buildShippingParams(this.estimator);

      if (!params.get('shipping_address[zip]')) {
        this.showMessage('Pop in a ZIP or postal code first.');
        return;
      }

      this.setLoading(true);
      this.showMessage('Sniffing out shipping rates...');

      try {
        await fetch(`${this.root}cart/prepare_shipping_rates.json?${params.toString()}`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        const rates = await this.pollRates(params);
        this.renderRates(rates);
      } catch (error) {
        this.showMessage('We couldn’t estimate shipping right now. Checkout will still calculate it securely.');
      } finally {
        this.setLoading(false);
      }
    }

    async pollRates(params) {
      for (let attempt = 0; attempt < 8; attempt += 1) {
        const response = await fetch(`${this.root}cart/async_shipping_rates.json?${params.toString()}`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (response.ok) {
          const payload = await response.json();
          if (Array.isArray(payload.shipping_rates)) return payload.shipping_rates;
        }

        await delay(600);
      }

      throw new Error('Shipping rates were not ready.');
    }

    renderRates(rates) {
      if (!rates.length) {
        this.showMessage('No rates showed up for that address yet. Checkout will confirm shipping.');
        return;
      }

      const list = document.createElement('ul');
      rates.forEach((rate) => {
        const item = document.createElement('li');
        const name = document.createElement('span');
        const price = document.createElement('strong');

        name.textContent = rate.name || 'Shipping';
        price.textContent = formatRatePrice(rate, this.currencySymbol);
        item.append(name, price);
        list.append(item);
      });

      this.result.replaceChildren(list);
    }

    showMessage(message) {
      this.result.textContent = message;
    }

    setLoading(isLoading) {
      this.button.disabled = isLoading;
      this.button.textContent = isLoading ? 'checking...' : 'estimate rates';
    }
  }

  const init = () => {
    document.querySelectorAll('[data-solvi-shipping-estimator]').forEach((estimator) => {
      if (!estimator.solviShippingEstimator) {
        estimator.solviShippingEstimator = new SolviShippingEstimator(estimator);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
